export { DetailPage, type DetailPageProps } from './detail-page';
export { DetailPageHeader, type DetailPageHeaderProps } from './detail-page-header';
